import script from "./OfferSide.vue?vue&type=script&setup=true&lang=ts"
export * from "./OfferSide.vue?vue&type=script&setup=true&lang=ts"

import "./OfferSide.vue?vue&type=style&index=0&id=a40f600c&scoped=true&lang=less"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a40f600c"]])

export default __exports__